module.exports = __webpack_public_path__ + "img/qrcode_new.d7ad9da1.jpg";